import { getTaskTable as getDiagramTaskTable } from '@process-advisor/process-miner/processMiner/processMiner';

type TaskTableProps = {
    taskTable?: string;
}

export const getTaskTable = (): TaskTableProps => getDiagramTaskTable();
